<template>
  <loading :active.sync="activeSyncProps" :is-full-page="isFullPageProps" :height="45" :width="45"
  :color="'var(--blue70)'" :backgroundColor="'var(--overlays-dark)'" :class="hiddenProps ? hiddenProps : ''"></loading>
</template>
<script>
    // Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name : 'LoadingOverlay',
        props : ['activeSyncProps', 'isFullPageProps','hiddenProps'],
        components : {Loading}
    }
</script>
